import styled from 'styled-components';


export const ContentContainer = styled("section")`
    width: 100%;
    padding: ${props => props.$padding || '150px 0'};
`;

export const ContainerFull = styled("section") `
    width: 100%;
    background-color: ${props => props.$backgroundColor || "#F8F9FA"};
    padding: ${props => props.$padding || '150px 0'};
`;





export const BasicContainer = styled("div")`
    position: relative;
    width: 100%;
    /* padding-top: 30px; */
    animation: fadeIn 1s;

    @keyframes fadeIn {
        from {
            opacity: 0;
            top: 30px;
        }
        to {
            opacity: 1;
            top: 0;
        }
    }
`;
